// The placeholder avatar for an account without a picture: its initials on a coloured
// disc, drawn here as an SVG data URI.
//
// It used to come from ui-avatars.com — and since the header shows a placeholder before
// anyone signs in, EVERY visitor's browser called that service on every page load,
// spectating parents and pupils included: their IP address, and once signed in their
// name, sent to a third party for a picture of two letters.

function escapeXml(s) {
    return String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&apos;' }[c]));
}

/** "Kari Nordmann" -> "KN", "Kari" -> "K", "" -> "?". Whole characters, not UTF-16 halves. */
export function initialsOf(name) {
    const words = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return '?';
    const first = Array.from(words[0])[0] || '';
    const last = words.length > 1 ? (Array.from(words[words.length - 1])[0] || '') : '';
    return (first + last).toUpperCase() || '?';
}

/**
 * @param {string} name        whose initials to draw
 * @param {string} [background] hex colour without '#'
 * @returns {string} a data: URI for an <img src>
 */
export function initialsAvatar(name, background = '3B82F6') {
    const bg = /^[0-9a-fA-F]{6}$/.test(String(background)) ? background : '3B82F6';
    const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">'
        + `<rect width="64" height="64" fill="#${bg}"/>`
        + '<text x="32" y="32" dy=".35em" text-anchor="middle" fill="#fff" font-size="26" font-weight="600" '
        + 'font-family="system-ui,-apple-system,Segoe UI,Roboto,sans-serif">'
        + escapeXml(initialsOf(name)) + '</text></svg>';
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
}
